import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import * as actions from "../../../store/actions/index";
import SlideOver from "../../../components/slideOver/SlideOver";
import {
  SetupActions,
  SetupPage,
  SetupTable,
  SetupTd,
} from "../../../components/setup/SetupPage";
import { PriceRulesViewModel } from "../../../viewmodels/setup/priceRules/PriceRulesViewModel";
import { withRouter } from "../../../shared/utility";

function PriceRules({ logout, addSnackbar }) {
  const vm = PriceRulesViewModel(logout, addSnackbar);
  const searchRef = useRef();
  const [first, setFirst] = useState(0);

  useEffect(() => {
    vm.getPriceRules("", 1);
  }, []);

  return (
    <div>
      <SetupPage
        title="Price Rules"
        description="Manage customer pricing groups and product-specific selling prices."
        searchPlaceholder="Search price rules"
        searchRef={searchRef}
        onSearch={() => vm.getPriceRules(searchRef.current?.value ?? "", 1)}
        actions={[{ label: "Add Price Rule", onClick: () => vm.openForm() }]}
        loading={vm.loading}
        tableColumns={["Name", "Description", "Customers"]}
        totalRecords={vm.priceRules.total}
        first={first}
        rows={20}
        onPageChange={(event) => {
          setFirst(event.first);
          vm.getPriceRules(searchRef.current?.value ?? "", event.page + 1);
        }}
      >
        <SetupTable
          columns={["Name", "Description", "Customers"]}
          emptyText="No price rules found."
        >
          {vm.priceRules.data?.map((rule) => (
            <tr key={rule.id} className="transition hover:bg-[#F6F8FB]/80">
              <SetupTd muted={false}>{rule.name}</SetupTd>
              <SetupTd>{rule.description || "—"}</SetupTd>
              <SetupTd>{rule.customers_count ?? 0}</SetupTd>
              <SetupActions>
                <button
                  type="button"
                  onClick={() => vm.openForm(rule)}
                  className="rounded-lg border px-3 py-1.5 text-sm font-semibold"
                >
                  Edit
                </button>
                <button
                  type="button"
                  onClick={() => vm.archivePriceRule(rule.id)}
                  className="ml-2 rounded-lg border border-red-200 px-3 py-1.5 text-sm font-semibold text-red-600"
                >
                  Archive
                </button>
              </SetupActions>
            </tr>
          ))}
        </SetupTable>
      </SetupPage>
      <SlideOver
        childComponent={vm.slideOver.childComponent}
        slideOver={vm.slideOver}
        setSlideOver={vm.setSlideOver}
      />
    </div>
  );
}

export default withRouter(
  connect(null, (dispatch) => ({
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  }))(PriceRules),
);
